import * as constants from './constants';

export default {
    // 试用订单余额
    [constants.kecTryOrder](state, res) {
        state.kecTryOrder = res.available_credit;
    },
    [constants.QueryKecData](state, res) {
        state.kecData = res.data;
        state.soldoutList = res.sellOutData;
        state.RootSizeQuota = res.RootSizeQuota || {};
    },
    [constants.kecRegions](state, res) {
        state.regionInfos = res || [];
    },
    [constants.kecImageList](state, res) {
        state.osImages = res.images || [];
        state.pTypeConfig = res.p_type_config || [];
    },
    [constants.kecDiyImage](state, res) {
        state.imageSet = res;
    },
    [constants.kecGetSnap](state, res) {
        state.snapList = res.LocalVolumeSnapshotSet || [];
        state.snapTotal = res.LocalVolumeSnapshotCount;
    },
    [constants.kecQueryDisCount](state, res) {
        state.disCountObj = res.disCountObj;
    },
    [constants.QueryPriceSystem](state, res) {
        state.kecData = res.data;
        state.soldoutList = res.sellOutData;
        state.RootSizeQuota = res.RootSizeQuota || {};
    },
    //--以下为未登录mutations--
    [constants.noLoginQueryKecData](state, res) {
        state.kecData = res.data;
        state.soldoutList = res.sellOutData;
        state.RootSizeQuota = res.RootSizeQuota || {};
    },
    [constants.noLoginkecImageList](state, res) {
        state.osImages = res.images || [];
        state.pTypeConfig = res.p_type_config || [];
    },
    [constants.noLoginKecQueryDisCount](state, res) {
        state.disCountObj = res.disCountObj;
    },
    //--以上为未登录mutations--
}
